<template>
  <div class="row">

    <div class="col-7">

      <b-row class="d-flex align-items-center">
        <label class="col-3">N. Orden AS400:</label>

        <b-form-input 
          id="v-norden" 
          v-model="nOrden" 
          type="text"
          class="col-6" 
        />
      </b-row>

      <b-row class="my-1 d-flex align-items-center">
        <div class="col-10">
          <SearchOpts
            v-model="tempLab400"
            :searchService="searchLab400ByName"
            placeholder="Buscar examen por nombre"
            :minChars="3"
            :omit="[]"
          /> 
        </div>

        <b-col md="2">
          <b-button
            :disabled="!tempLab400"
            variant="warning" 
            size="sm" 
            @click="addListaPrevia()"
            style="cursor: pointer;"
            title="add"
          >
            +
          </b-button>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <div class="col-11" v-if="justificacionMismaOrden || justificacionOtrasOrdenes || justificacion">
          <span>Justificacion:</span>

          <b-form-textarea
            v-model="justificacion"
            rows="2"
          />
        </div>
      </b-row>
      
    </div>
    

    <div class="col-5">
      <b-alert 
        variant="secondary" 
        show 
        class="p-2 col"
        v-if="listaPrevia && listaPrevia.length"
      >
        <h4 class="mb-1">Listado Previo de Examenes a Enviar</h4>
        <div 
          v-for="(item, index) in listaPrevia" 
          :key="index"
          class="mb-1 row d-flex align-items-center"
        >
          <span class="col-8">{{ item.text }}</span>
          <div class="col">
            <b-button
              variant="danger"
              size="sm"
              @click="onRemoveListaPrevia(index)"
            >x</b-button>
          </div>
        </div>
      </b-alert>

      <b-row 
        v-if="listaPrevia && listaPrevia.length" 
        class="d-flex align-items-center justify-content-end mx-1"
      >
        <b-button
          v-if="!indexToEdit"
          variant="primary" 
          size="sm" 
          @click="agregarOrden400()"
          style="cursor: pointer;"
          title="Agregar Laboratorio Auxiliar"
        >
          + Agregar
        </b-button>

        <b-button
          v-if="indexToEdit"
          variant="primary" 
          size="sm" 
          @click="editarOrden400()"
          style="cursor: pointer;"
        >
          Guardar
        </b-button>


      </b-row>
    </div>

  </div>
</template>

<script>
import { SearchOpts }           from '@/shared/components';
import { searchLabByName }      from '@/views/atencionCita/helpers/searchLabByName';
import { getEstablecimientoLS } from "@/shared/helpers";

import { labAs400Service } from "@/views/laboratorio/services";


export default {

  name: "FormAddLabA400",

  props:{
    examenes400: { 
      type: Array, 
      default: () => [] 
    },

    indexToEdit:{
      type: String,
      default:null
    }
  },

  components: {
    SearchOpts,
  },


  created(){
    if(this.indexToEdit) this.loadDataToEdit()
  },


  data(){
    return {
      searchLabByName,

      tempLab400: null,
      nOrden: null,
      justificacion: null,
      listaPrevia:[],

      labToEdit: null,

      justificacionMismaOrden: false,
      justificacionOtrasOrdenes: false
    }
  },


  methods:{


    loadDataToEdit(){
      const labToEdit = { ...this.examenes400[this.indexToEdit] }

      this.labToEdit     = labToEdit
      this.nOrden        = labToEdit.codigoOrden
      this.listaPrevia   = [...labToEdit.laboratorios];
      this.justificacion = labToEdit.justificacion;
    },


    async searchLab400ByName(search) {
      const establecimiento = getEstablecimientoLS();
      const responseSearch400 = await labAs400Service.searchLab(search, establecimiento.id);

      // Filtrar duplicados por código
      const seenCodes = new Set();
      const uniqueLabs = responseSearch400.filter(result => {
        if (seenCodes.has(result.codigo)) return false;
        
        seenCodes.add(result.codigo);
        return true;
      });

      // Mapear a la estructura deseada
      const labMapped = uniqueLabs.map(result => {
        return {
          ...result,
          value: result.id,
          text: `(${result.codigo}) ${result.descripcion}`
        };
      });

      return labMapped;
    },
 

    addListaPrevia(){
      this.listaPrevia.push(this.tempLab400);
      this.tempLab400 = null;
    },

    onRemoveListaPrevia(index){
      this.listaPrevia.splice(index, 1);
    },


    agregarOrden400() {

      if(!this.nOrden){
        this.$swal({
          title: 'Error',
          text: 'Por favor, ingrese un número de orden.',
          icon: 'error',
        });
        return;
      }

      if (!this.listaPrevia || !this.listaPrevia.length) {
        this.$swal({
          title: 'Error',
          text : 'Por favor, seleccione un examen antes de agregar.',
          icon : 'error',
          confirmButtonColor: '#089599',
        });

        return;
      } 

      const hayRepetidosListaPrevia = this.validarRepetidosListaPrevia();
      if(hayRepetidosListaPrevia) return;

      // const hayRepetidosEnOtrasOrdenes = this.validateRepetidosOtrasOrdenes();
      // if (hayRepetidosEnOtrasOrdenes) return;


      const nuevaOrden = {
        accion            : "crear",
        estadoLaboratorio : '0',
        codigoOrden       : this.nOrden,
        laboratorios      : this.listaPrevia,
        justificacion     : this.justificacion,
      };

      this.examenes400.push(nuevaOrden);
      // this.limpiarFormularioAuxiliar();
    },


    editarOrden400() {
      if (!this.listaPrevia || this.listaPrevia.length === 0) {
        this.$swal({
          title: 'Error',
          text : 'Por favor, seleccione un examen antes de guardar.',
          icon : 'error',
          confirmButtonColor: '#089599',
        });

        return;
      } 

      const hayRepetidosListaPrevia = this.validarRepetidosListaPrevia();
      if(hayRepetidosListaPrevia) return;

      // const hayRepetidosEnOtrasOrdenes = this.validateRepetidosOtrasOrdenes();
      // if (hayRepetidosEnOtrasOrdenes) return;


      const ordenEditada = {
        ...this.labToEdit,
        accion        : this.labToEdit.accion === 'registrado' ? 'editar' : this.labToEdit.accion,
        codigoOrden   : this.nOrden,
        laboratorios  : this.listaPrevia,
        justificacion : this.justificacion,
      }

      this.$set(this.examenes400, this.indexToEdit, ordenEditada);
      this.limpiarFormulario();
      this.$bvModal.hide('editLab');
    },


    limpiarFormulario() {
      this.listaPrevia = [];
      this.nOrden = null;
      this.justificacion = null;
      this.justificacionMismaOrden = false;
      // this.justificacionOtrasOrdenes = false;
    },


    validarRepetidosListaPrevia(){

      const hayRepetidos = this.listaPrevia.some(
        (item, index, arr) => arr.findIndex(obj => obj.codigo === item.codigo) !== index
      );

      this.justificacionMismaOrden = hayRepetidos;

      if(hayRepetidos && !this.justificacion){
        this.$swal({
          title: 'Advertencia',
          text: 'Examenes repetidos en la misma orden debe ingresar una justificacion.',
          icon: 'warning',
          confirmButtonColor: '#089599',
        });

        return true;
      }

      return false;
    },


  }, 



  computed:{
    omitLab400(){
      const omits = this.listaPrevia.map(
        l => ({ id: l.id, token: null })
      );
      return omits; 
    },
  },

  watch:{


  }

}
</script>
